// Background Images - Easy Access Export
// To add a new background:
// 1. Add the image file to this folder
// 2. Add the import below
// 3. Add to the backgrounds object
// 4. Update config.js with background info

import cream from './cream.png';
import mobile from './mobile.png';
import foody from './foody.png';

// Centralized backgrounds object - frozen for performance (prevents mutations)
export const backgrounds = Object.freeze({
  cream,
  foody,
  mobile,
});

// Export individually for direct import (if needed)
export { cream, foody, mobile };

// Default export (all backgrounds as object)
export default backgrounds;

// Memoized helper function to get background with fallback
const backgroundCache = new Map();

export const getBackground = (key, fallback = 'foody') => {
  const cacheKey = `${key}-${fallback}`;
  
  if (!backgroundCache.has(cacheKey)) {
    const result = backgrounds[key] || backgrounds[fallback] || backgrounds.foody;
    backgroundCache.set(cacheKey, result);
  }
  
  return backgroundCache.get(cacheKey);
};

